
export default {
  data() {
    return {
      options: [
        {
          name: "title",
          label: "Naslov",
          type: "text",
        },
        {
          name: "subtitle",
          label: "Podnaslov",
          type: "textarea",
        },
        {
          name: "description",
          label: "Opis",
          type: "tipTap",
        },
        {
          name: "image",
          label: "Slika",
          type: "image",
          size: "150x150",
        },
      ],
    };
  },
  methods: {
    addActiveClass(e) {
      const el = e.currentTarget;
      el.classList.add("active");
    },
    removeActiveClass(e) {
      const el = e.currentTarget;
      el.classList.remove("active");
    },
  },
};
